var FX = (function(FX, $) {
    $(function() {
        FX.Product.init();
    });

    // Component for Alpine.js - currently just for wishlist
    FX.ProductPage = {
        product: {},
        userLists: [],
        selectedListID: '',
        selectedListName: '',
        listModalOpen: false,
        addingList: false,
        newListName: '',

        init: function() {
            this.product = initialState.product;
        },
        initLoggedIn: function() {
            this.init();
            const options = {
                endpoint: 'userlist',
                method: 'GET',
                success: $.proxy( this.basicResponse, this ),
            };
            FX.AJAX.callREST(options);
        },
        addList: function() {
            const data = { name: this.newListName };
            const options = {
                endpoint: 'userlist',
                data: data,
                success: $.proxy( this.basicResponse, this ),
            };
			FX.AJAX.callREST(options);
        },
        addItem: function() {
            const data = {
                part_id: this.product.partID,
                embroidery_id: this.product.embroideryID,
                alias_id: this.product.aliasID,
                qty: this.product.qty,
            };
            const options = {
                endpoint: 'userlist/' + this.selectedListID + '/items',
                data: data,
                success: $.proxy( this.itemAddResponse, this ),
            };
            FX.AJAX.callREST(options);
        },
        basicResponse: function(response) {
            if (response.success) {
                this.userLists = response.data;
                if ( this.userLists.length === 1 ) {
                    this.selectedListID = this.userLists[0].id;
                    this.selectedListName = this.userLists[0].name;
                }
                this.addingList = false;
                this.newListName = '';
            }
        },
        itemAddResponse: function(response) {
            this.basicResponse(response);
            this.listModalOpen = false;
            const label = FX.currentSite === 'tfa' ? 'Wishlists' : 'Baskets';
            $( '.emb-commerce-message-container' ).html( '<span class="cart-success">Item added to "' + this.selectedListName + '". <a href="/my-account/?view=userlist" class="btn btn-secondary"><span>View ' + label + '</span></a></span>' );
            if ( $( '#page-body' ).offset().top < $( window ).scrollTop()) {
                FX.SmoothAnchors.scrollToSmooth( '#page-body' );
            }
        }
    };

    FX.Product = {
        init: function() {
            // Initialize for add items to cart
            FX.Product.$selectedProductInput = $( '#selected_product_id' );
            FX.Product.$selectedAliasInput   = $( '#selected_alias_id' );
            FX.Product.$quantityInput        = $( '#product_qty' );
            FX.Product.$embroideryInput      = $( '#product_embroidery_id' );
            FX.Product.$cartButton           = $( '#add_to_cart_button' );
            FX.Product.baseProductID         = $( '.js-part-id' ).first().text();
            FX.Product.$attributes           = $( '.attribute-select' );
            FX.Product.$userListSection      = $( '.product-page-summary__userlist' );
            FX.Product.requiresEmbroidery    = false;
            FX.Product.requiresVariations    = false;
            // Variable product
            if ( FX.Product.$attributes.length ) {
                FX.Product.requiresVariations = true;
                FX.Product.$attributes.select2({
                    allowClear: true,
                    minimumResultsForSearch: 10 // at least 10 variations must exist for this option to be searchable
                });
                FX.Product.$attributes.on( 'change', FX.Product.updateVariation );
                FX.Product.isUpdatedContent = false;
                FX.Product.mediaSection           = '.product-page-media-gallery-wrapper';
                FX.Product.mediaSectionHTML       = $( FX.Product.mediaSection )[0].outerHTML;
                FX.Product.detailsSection         = '.product-page-summary__details-wrapper';
                FX.Product.detailsSectionHTML     = $( FX.Product.detailsSection )[0].outerHTML;
                FX.Product.applicationSection     = '.product-page-summary__application-wrapper';
                FX.Product.applicationSectionHTML = $( FX.Product.applicationSection )[0].outerHTML;
                FX.Product.productTabs            = '.product-tabs';
                FX.Product.productTabsHTML        = $( FX.Product.productTabs )[0].outerHTML;
                let triggerVariationUpdate     = false;
                let context                    = null;
                FX.Product.$attributes.each( function() {
                    if ( $( this ).val() ) {
                        triggerVariationUpdate = true;
                        context                = this;
                    }
                });
                if ( triggerVariationUpdate ) {
                    FX.Product.updateVariation.call( context );
                }
            }//end if

            // Has embroidery option
            if ( $( 'select#product_embroidery_id' ).length ) {
                FX.Product.requiresEmbroidery = true;
                FX.Product.$embroideryInput.select2({
                    allowClear: true,
                    minimumResultsForSearch: 10
                });
                FX.Product.$embroideryInput.change( function() {
                    const embroideryID = $( this ).val();
                    FX.ProductPage.product.embroideryID = embroideryID;
                    FX.Product.requiresEmbroidery = embroideryID ? false : true;
                    if ( ! FX.Product.requiresVariations && ! FX.Product.requiresEmbroidery ) {
                        FX.Product.enableActions();
                    } else {
                        FX.Product.disableActions();
                    }
                });
            }
            
            if ( ! FX.Product.requiresVariations && ! FX.Product.requiresEmbroidery ) {
                FX.Product.enableActions();
            }

            FX.Product.$quantityDecrement = $( '.quantity-minus-btn' );
            FX.Product.$quantityIncrement = $( '.quantity-plus-btn' );
            FX.Product.$quantityDecrement.on( 'click', FX.Product.decrementQuantity );
            FX.Product.$quantityIncrement.on( 'click', FX.Product.incrementQuantity );

            FX.Product.$cartButton.on( 'click', FX.Product.addToCart );
            $( '.review_anchor a' ).on( 'click', function() {
                FX.TabsAndAccordion.changeVisibility.call( $( '.js-reviews-click-target' ) );
                FX.SmoothAnchors.scrollToSmooth( '#product-page-bottom-anchor-target' );
                return false;
            });
            FX.Product.initProductMediaSliders();
        },

        // Quantity functions
        decrementQuantity: function() {
            let $quantityInput = $( this ).next(),
                newVal         = parseInt( $quantityInput.val() ) - 1;
            if ( newVal < 1 ) {
                newVal = 1;
            }
            $quantityInput.val( newVal );
        },
        incrementQuantity: function() {
            let $quantityInput = $( this ).prev();
            $quantityInput.val( parseInt( $quantityInput.val() ) + 1 );
        },

        // Cart manipulation functions
        addToCart: function(e) {
            if ( $( this ).hasClass( 'disabled' ) ) {
                e.preventDefault();
                e.stopPropagation();
                alert( 'Please select all options before adding to cart' );
                return false;
            }
            const settings = {
                data: {
                    action: "add_to_cart",
                    part_id: FX.Product.$selectedProductInput.val(),
                    alias_id: FX.Product.$selectedAliasInput.val(),
                    quantity: FX.Product.$quantityInput.val(),
                    embroidery_id: FX.Product.$embroideryInput.val()
                },
                type: 'POST',
                success: FX.Product.ajaxSuccess,
                error: FX.Product.ajaxError
            };
            $.ajax( FX.ajaxurl, settings );

            if ( FX.currentSite === 'tfa' ) {
                // Measure adding a product to a shopping cart by using an 'add' actionFieldObject and a list of productFieldObjects.
                window.dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': 'US',
                        'add': { // 'add' actionFieldObject measures
                            'products': [
                                { // adding a product to a shopping cart
                                    'id': FX.Product.$selectedProductInput.val(),
                                    'quantity': FX.Product.$quantityInput.val()
                                }
                            ]
                        }
                    }
                });
            }
        },

        // Product display functions
        initProductMediaSliders: function() {
            $( '.product-page-main-img' ).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.product-page-thumbs',
                arrows: false,
                infinite: false,
                draggable: false,
                slide: '.product-slide__main',
                rows: 0
            });
            if ( $( '.product-page-thumbs .product-slide__thumb' ).length > 1 ) {
                $( '.product-page-thumbs' ).slick({
                    dots: false,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" class="slick-prev"><span class="flaticon-back"></span></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="flaticon-forward"></span></button>',
                    asNavFor: '.product-page-main-img',
                    infinite: false,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                arrows: false,
                                infinite: true
                            }
                        }
                    ]
                });
            }//end if
        },
        enableActions: function() {
            FX.Product.$cartButton.removeClass( 'disabled' );
            FX.Product.$userListSection.removeClass( 'hidden' ); 
        },
        disableActions: function() {
            FX.Product.$cartButton.addClass( 'disabled' );
            FX.Product.$userListSection.addClass( 'hidden' ); 
        },
        updateVariation: function() {
            let atts         = {},
                urlParamAtts = {},
                $selectedAtt = $( this );
            // Create list of all user-selected attributes
            FX.Product.$attributes.each( function(index, element) {
                let $el = $( element );
                // Only send att if att is not disabled; only send "product_choice" if the changed dropdown was "product_choice"
                if ( 'disabled' !== $el.attr( 'disabled' ) && ( 'product_choice' !== $el.data( 'attribute' ) || 'product_choice' === $selectedAtt.data( 'attribute' ) ) ) {
                    atts[ $el.data( 'attribute' ) ] = $el.val();
                    if ( $el.val() && 'product_choice' !== $el.data( 'attribute' ) ) {
                        urlParamAtts[ $el.data( 'attribute' ) ] = $el.val();
                    }
                }
            });

            FX.Product.$attributes.attr( 'disabled', true ); // Disable dropdowns to prevent modifications while processing is happening
            FX.Product.disableActions();

            // Send attributes to server and parse response
            $.post(
                FX.ajaxurl,
                {
                    action: 'get_variation_data',
                    part_id: FX.Product.baseProductID,
                    atts: atts,
                    just_changed: $selectedAtt.data( 'attribute' )
                },
                function( response ) {
                    let needsRefresh     = false, // Helps determine whether JS bindings need to be re-initialized
                        hasProductChoice = false; // Helps determine whether multiple product matches were found and fallback "Choose Product" dropdown should display
                    FX.Product.$attributes.attr( 'disabled', false );
                    $( '.js-no-products-found' ).hide();
                    if ( false === response.success ) {
                        $( '.js-no-products-found' ).show();
                        $( '.product-page-summary__choice-section.attribute-product-select' ).hide();
                        return;
                    }
                    // If response includes filtered attribute values, rebuild associated attribute dropdowns to match
                    if ( response.data.atts ) {
                        $.each( response.data.atts, function( att, options ) {
                            let $attDropdown = $( 'select[data-attribute="' + att + '"]' ),
                                currVal      = $attDropdown.val();
                            $attDropdown.find( 'option:gt(0)' ).remove();
                            options.forEach( function( option ) {
                                let attVal  = option,
                                    attText = option;
                                if ( 'product_choice' === att ) {
                                    attVal = option.id;
                                    attText = option.name + ' (Part # ' + option.id + ')';
                                    $attDropdown.parents( '.product-page-summary__choice-section' ).show();
                                    $attDropdown.attr( 'disabled', false );
                                    hasProductChoice = true;
                                }
                                $attDropdown.append( $( '<option/>', { value: attVal, text: attText } ) );
                            });
                            if ( 1 === options.length ) {
                                // If a filtered attribute only has one option, auto-select that option and disable dropdown
                                $attDropdown.val( options[0] );
                                $attDropdown.attr( 'disabled', true );
                            } else if ( false === response.data.reset_selected ) {
                                $attDropdown.val( currVal );
                            } else {
                                $attDropdown.val( '' );
                            }
                        });
                        if ( ! response.data.show_product_choice ) {
                            // If product choices weren't sent back from server, and no part has been selected, clear/hide "Choose Product" dropdown
                            $( 'select[data-attribute="product_choice"]' )
                                .attr( 'disabled', true )
                                .find( 'option:gt(0)' ).remove();
                            $( 'select[data-attribute="product_choice"]' ).parents( '.product-page-summary__choice-section' ).hide();
                        }
                    }//end if
                    // If response contains any HTML fragments, insert those into page
                    if ( ! $.isEmptyObject( response.data.fragments ) ) {
                        $.each( response.data.fragments, function( className, html ) {
                            $( '.' + className ).replaceWith( html );
                        });
                        needsRefresh             = true;
                        FX.Product.isUpdatedContent = true;
                    }
                    FX.ProductPage.product.partID = '';
                    if ( 'product_found' === response.data.status && response.data.partID ) {
                        // Matching product was found
                        FX.Product.$selectedProductInput.val( response.data.partID );
                        FX.Product.requiresVariations = false;
                        // If no embroidery options are still required, enable and show Add to Cart and Add to Wishlist/Basket
                        if ( ! FX.Product.requiresEmbroidery ) {
                            FX.Product.enableActions();   
                        }
                        FX.ProductPage.product.partID = response.data.partID;
                    } else if ( FX.Product.isUpdatedContent ) {
                        // No variation matched this request, and the content had already been updated to match a particular product - reset to beginning page state
                        if ( $.isEmptyObject( response.data.fragments ) ) {
                            $( FX.Product.mediaSection ).replaceWith( FX.Product.mediaSectionHTML );
                        }
                        $( FX.Product.detailsSection ).replaceWith( FX.Product.detailsSectionHTML );
                        $( FX.Product.applicationSection ).replaceWith( FX.Product.applicationSectionHTML );
                        $( FX.Product.productTabs ).replaceWith( FX.Product.productTabsHTML );
                        FX.Product.isUpdatedContent = false;
                        needsRefresh             = true;
                    }
                    if ( needsRefresh ) {
                        FX.Product.initProductMediaSliders();
                        FX.MagnificPopup.init();
                        FX.TabsAndAccordion.init();
                        if ( FX.currentSite === 'tfa' ) {
                            affirm.ui.refresh();
                        }
                    }
                    let urlAtts = $.isEmptyObject( urlParamAtts ) ? window.location.pathname : '?' + $.param( urlParamAtts );
                    window.history.replaceState( null, null, urlAtts );
                }
            );
        },

        // AJAX handlers
        ajaxSuccess: function(data) {
            $( '.emb-commerce-message-container' ).html( '<span class="cart-success">' + data.data.message + '</span>' );
            FX.HeaderCart.updateLocalCartCount(FX.Product.$quantityInput.val());
            FX.HeaderCart.updateHeaderCart();
            if ( $( '#page-body' ).offset().top < $( window ).scrollTop()) {
                FX.SmoothAnchors.scrollToSmooth( '#page-body' );
            }
        },
        ajaxError: function(data) {
            $( '.emb-commerce-message-container' ).html( '<span class="cart-error">' + data.responseJSON.data + '</span>' );
            if ( $( '#page-body' ).offset().top < $( window ).scrollTop()) {
                FX.SmoothAnchors.scrollToSmooth( '#page-body' );
            }
        },
    };
    return FX;
}(FX || {}, jQuery));
